/**
 * Icon Components - Centralized icon library
 * Using react-icons for consistent, professional icons
 */
import {
  HiOutlineChartBar,
  HiOutlineMegaphone,
  HiOutlineDocumentText,
  HiOutlineUsers,
  HiOutlineClipboardDocumentList,
  HiOutlineArrowRightOnRectangle,
  HiOutlineExclamationTriangle,
  HiOutlineCheckCircle,
  HiOutlineXCircle,
  HiOutlineInformationCircle,
  HiOutlineEnvelope,
  HiOutlineClock,
  HiOutlineUserGroup,
  HiOutlinePaperAirplane,
  HiOutlineChatBubbleLeftRight,
  HiOutlineEye,
  HiOutlineEyeSlash,
  HiOutlineUser,
  HiOutlineCog6Tooth,
  HiOutlineBell,
  HiOutlineChevronDown,
  HiOutlineUserCircle,
} from 'react-icons/hi2';

import {
  FaRocket,
} from 'react-icons/fa';

// Navigation Icons
export const DashboardIcon = HiOutlineChartBar;
export const CampaignsIcon = HiOutlineMegaphone;
export const TemplatesIcon = HiOutlineDocumentText;
export const LeadsIcon = HiOutlineUsers;
export const LogsIcon = HiOutlineClipboardDocumentList;
export const LogoutIcon = HiOutlineArrowRightOnRectangle;
export const RocketIcon = FaRocket;

// Status Icons
export const SuccessIcon = HiOutlineCheckCircle;
export const ErrorIcon = HiOutlineXCircle;
export const WarningIcon = HiOutlineExclamationTriangle;
export const InfoIcon = HiOutlineInformationCircle;

// Feature Icons
export const EmailIcon = HiOutlineEnvelope;
export const MessageIcon = HiOutlineChatBubbleLeftRight;
export const EnvelopeIcon = HiOutlineEnvelope;
export const ClockIcon = HiOutlineClock;
export const UsersIcon = HiOutlineUserGroup;
export const SendIcon = HiOutlinePaperAirplane;

// Password visibility icons
export { HiOutlineEye, HiOutlineEyeSlash };

// Top Header Icons
export { 
  HiOutlineUser, 
  HiOutlineCog6Tooth, 
  HiOutlineBell, 
  HiOutlineChevronDown, 
  HiOutlineUserCircle 
};

// Export logout icon (using ArrowRightOnRectangle as it's the logout icon in Heroicons v2)
export const HiOutlineLogout = HiOutlineArrowRightOnRectangle;

// Icon wrapper for consistent sizing
export function Icon({ component: IconComponent, size = 20, className = '', ...props }) {
  return <IconComponent size={size} className={className} {...props} />;
}

